import React from 'react';
import back from './pdapMemberCardBack.png';

export const PdapMemberCardBack = () => (
    <div style={{ border: '1px solid #464646', borderRadius: '25px', padding: '15px' }}>
        <span><img src={back} alt="PDAP Member Card Back" className="img-responsive" /></span>
    </div>
);
